let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6ge9a")).then(() => parcelRequire('aBZC5'));